<template>
  <el-popover v-model="state" placement="top-start" trigger="manual" class="error-info">
    <div class="pop-content">
      <div class="pop-head">
        <h3>请检查以下选项：</h3>
      </div>
      <ul type="disc">
        <li v-for="(msg, idx) in data" :key="idx">
          <span>{{ msg.feild }}</span>
          <ins>1、{{ msg.msg }}</ins>
        </li>
      </ul>
    </div>
    <div class="info-reference" slot="reference" v-show="state">
      <i class="el-icon-warning" :style="{ fontSize: '18px', color: '#f45858' }"></i>
      <span class="info-txt">有些项目填写错误，请修改</span>
    </div>
  </el-popover>
</template>
<script>
import { timeout } from '@/common/js/utils'
export default {
  name: 'ErrorPop',
  props: {
    value: {
      type: Boolean
    },
    state: {
      type: Boolean
    },
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    visiable: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
      timeout(300).then(() => {
        this.$emit('close', false)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.info-reference {
  display: flex;
  align-items: center;
  line-height: 32px;

  .info-txt {
    margin-left: 8px;
  }
}
.pop-content {
  min-width: 160px;
  .pop-head {
    font-size: 14px;
    line-height: 32px;
  }
  ul {
    padding: 12px 24px;
    border: solid 1px #f45858;
    background-color: #fcf6f6;
    li {
      list-style-type: disc;
      margin-bottom: 10px;
      font-size: 14px;
      ins {
        font-size: 12px;
        display: block;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
